export default __webpack_public_path__ + "static/media/ico_pdf.26c6f548.png";